var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClients = function SvgClients(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 176 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.54 47.8c-.04.01-.08.02-.13.02l-.78.18c-9.57 2.1-16.72 10.5-16.72 20.56h42.76c0-10.17-7.32-18.66-17.06-20.63l-.41-.11c-9.86-1.82-12.67-7.1-12.67-7.1",
    stroke: "#fff",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.88 42.36c-4.1-4.03-4.1-10.57 0-14.6 4.09-4.03 10.73-4.03 14.83 0s4.1 10.57 0 14.6",
    stroke: "#fff",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.089 40.72s-2.79 5.24-12.55 7.08",
    stroke: "#fff",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.29 89.66c23.759 0 43.02-19.26 43.02-43.02S131.049 3.62 107.29 3.62c-23.76 0-43.02 19.26-43.02 43.02s19.26 43.02 43.02 43.02ZM125.849 131.13c-.04.01-.08.02-.13.02l-.78.18c-9.57 2.1-16.72 10.5-16.72 20.56h42.76c0-10.17-7.32-18.66-17.06-20.63l-.41-.11c-9.86-1.82-12.67-7.1-12.67-7.1",
    stroke: "#fff",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.19 125.69c-4.1-4.03-4.1-10.57 0-14.6 4.09-4.03 10.73-4.03 14.83 0s4.1 10.57 0 14.6",
    stroke: "#fff",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138.4 124.061s-2.79 5.24-12.55 7.08",
    stroke: "#fff",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.6 172.78c23.759 0 43.02-19.26 43.02-43.02 0-23.759-19.261-43.02-43.02-43.02-23.759 0-43.02 19.261-43.02 43.02 0 23.76 19.261 43.02 43.02 43.02ZM42.95 108.56c-.04.01-.08.02-.13.02l-.78.18c-9.57 2.1-16.72 10.5-16.72 20.56h42.76c0-10.17-7.33-18.66-17.06-20.63l-.41-.11c-9.86-1.82-12.67-7.1-12.67-7.1",
    stroke: "#fff",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.29 103.121c-4.1-4.03-4.1-10.57 0-14.6 4.1-4.03 10.73-4.03 14.83 0a10.22 10.22 0 0 1 0 14.6",
    stroke: "#fff",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 101.48s-2.79 5.23-12.55 7.08",
    stroke: "#fff",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.62 150.51c23.759 0 43.02-19.261 43.02-43.02 0-23.76-19.261-43.02-43.02-43.02-23.76 0-43.02 19.26-43.02 43.02 0 23.759 19.26 43.02 43.02 43.02Z",
    stroke: "#fff",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })));
};

export default SvgClients;